// extracted by mini-css-extract-plugin
export default {"nizza":"CreateResearchModal_nizza__QQgtX","dialer":"CreateResearchModal_dialer__Z+O3U"};